/**
 * Контракт ошибок API.
 *
 * Сервер никогда не отдаёт «сырой» текст ошибки. Он отдаёт код, по которому
 * фронт выбирает переведённое сообщение, и опциональные детали для подстановки.
 */

export const API_ERROR_CODES = [
  'VALIDATION_FAILED',
  'UNAUTHORIZED',
  'INVALID_CREDENTIALS',
  'ACCOUNT_BLOCKED',
  'TOKEN_EXPIRED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'USERNAME_TAKEN',
  'WORKSPACE_SLUG_TAKEN',
  'LIMIT_EXCEEDED',
  'REGISTRATION_CLOSED',
  'INVITE_INVALID',
  'INVITE_EXHAUSTED',
  'RATE_LIMITED',
  'FILE_TOO_LARGE',
  'FILE_TYPE_NOT_ALLOWED',
  'STORAGE_QUOTA_EXCEEDED',
  'INSUFFICIENT_FUNDS',
  'WALLET_CURRENCY_MISMATCH',
  'PAYOUT_ALREADY_PAID',
  'PAYOUT_AMOUNT_EXCEEDS_REMAINDER',
  'CANNOT_DELETE_WITH_HISTORY',
  'PLAN_IN_USE',
  'DEMO_RESTRICTED',
  'INTERNAL_ERROR',
] as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[number];

export interface ApiFieldError {
  path: string;
  message: string;
}

export interface ApiErrorBody {
  error: {
    code: ApiErrorCode;
    /** Технический текст для логов — на фронте не показывается напрямую. */
    message: string;
    /** Данные для подстановки в перевод: { used: 12, max: 12 }. */
    details?: Record<string, unknown>;
    fields?: ApiFieldError[];
  };
}

export function isApiErrorBody(value: unknown): value is ApiErrorBody {
  return (
    typeof value === 'object' &&
    value !== null &&
    'error' in value &&
    typeof (value as ApiErrorBody).error?.code === 'string'
  );
}

/** Ключ перевода для кода ошибки: errors.LIMIT_EXCEEDED */
export function errorTranslationKey(code: ApiErrorCode): string {
  return `errors:${code}`;
}

export const API_PREFIX = '/api';
